module.exports = __webpack_public_path__ + "static/media/doctor.4fc6e69a.png";